import React, { useState } from 'react';
import styles from "./styles.module.scss";
import DocUploadModal from '../../../../../../views/pages/manage/unAssigned/studentCharges/studentChargesDetails/paymentMode/DocUploadModal';
import CustomDatePickerV2 from '../../../../../../views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import { Dialog } from '@mui/material';
import AInput from '../../../../../../views/pages/manage/common/formFeilds/customInput/AInput';
import AAutoComplete from '../../../../../../views/pages/manage/common/form-fields-mui/AAutoComplete';
import UploadDocument from '../../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/UploadDocument';
import AButton from '../../../../../../views/pages/manage/common/form-fields-mui/AButton';
import { regex } from '../../../../../../views/pages/manage/common/constant';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { failureToast } from '../../../../../../views/pages/manage/common/utils/methods/toasterFunctions/function';

const ChequeDetailsFormDialog = ({
    chequeDetailsForm,
    viewOnly,
    setChequeDetailsForm,
    dialogInfo,
    setDialogInfo,
    bankDropdown,
    fieldsConfig
}) => {


    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

    const formHandler = (key, val) => setChequeDetailsForm(prev => ({ ...prev, [key]: val }));

    const {isOpen , prevChequeDetails} = dialogInfo;

    const allMandatoryFieldsEntered = () => {
        const mandatoryFields = ["bankMasterId", "beneficiaryName", "paymentModeDate", "accountNumber", "attachmentKey"];
        return mandatoryFields.every(field => Boolean(chequeDetailsForm[field]));
    }

    const bank = chequeDetailsForm?.bank ?? bankDropdown?.find(bank => bank?.value == chequeDetailsForm?.bankMasterId);

    const closeDialog = () => setDialogInfo({isOpen : false, prevChequeDetails : {}});

    const saveChequeDetails = () => {
        if (chequeDetailsForm?.accountNumber?.length !== 6) {
            failureToast("Cheque number must be 6 digit long!");
            return;
        }

        formHandler("chequeDetailsSaved", true);
        closeDialog();
    }

    const crossHandler = () => {
        setChequeDetailsForm({...prevChequeDetails});
        closeDialog();
    }

    return (
        <Dialog
            open={!!isOpen}
            maxWidth={"md"}
            fullWidth
        >
            <div className={`${styles['dialog-container']}`}>


                <div className='d-flex justify-content-between'>
                    <div className={`${styles['dialog-heading']}`}>Pay via cheque</div>
                    <div className='d-flex'>
                        <CrossIcon className='ml-2' onClick={crossHandler} />
                    </div>
                </div>

                <div className={`${styles['form']}`}>

                    <div>
                        <AInput
                            label="Beneficiary Name*"
                            placeholder="Enter"
                            value={chequeDetailsForm?.beneficiaryName}
                            handler={(val) => {
                                formHandler("beneficiaryName", val);
                            }}
                            disabled={viewOnly}
                        />
                    </div>

                    <div>
                        <AInput
                            label="Cheque Number*"
                            placeholder="Enter"
                            value={chequeDetailsForm?.accountNumber}
                            handler={(val) => {
                                formHandler("accountNumber", val);
                            }}
                            regex={regex.numeric}
                            maxLength={6}
                            disabled={viewOnly}
                        />
                    </div>



                    <div>
                        <CustomDatePickerV2
                            label={fieldsConfig?.chequeDate?.label ?? "Refund Cheque Date*"}
                            value={chequeDetailsForm?.paymentModeDate}
                            handler={(index, date) => {
                                formHandler("paymentModeDate", date);
                            }}
                            placeHolder={"Select Refund Cheque Date"}
                            disabled={viewOnly}
                            maxDate={fieldsConfig?.chequeDate?.maxDate}
                            minDate={fieldsConfig?.chequeDate?.minDate}
                        />
                    </div>

                    <AAutoComplete
                        label='Bank Code*'
                        currentValue={bank}
                        handleChange={(val) => {
                            formHandler("bank", val);
                            formHandler("bankMasterId", val?.id);
                            formHandler("bankKey", val?.bankId);
                        }}
                        items={bankDropdown}
                        isMulti={false}
                        isDisabled={viewOnly}
                    />



                    <UploadDocument
                        attachmentKey={chequeDetailsForm?.attachmentKey}
                        setUploadDialogOpen={setUploadDialogOpen}
                        formHandler={formHandler}
                        viewOnly={viewOnly}
                        label='Add Attachment*'
                    />


                </div>

                {
                    !viewOnly &&
                    <AButton
                        variant='primary_filled'
                        className='no-ml-btn'
                        disabled={!allMandatoryFieldsEntered()}
                        onClick={saveChequeDetails}
                    >
                        Save cheque
                    </AButton>
                }


                <DocUploadModal
                    open={uploadDialogOpen}
                    setOpen={setUploadDialogOpen}
                    acceptedFileTypes={[".jpg", ".jpeg", ".png", ".pdf"]}
                    maxUploadFileSize={5}
                    serviceName={'STUDENT_BANK_ATTACHMENT'}
                    uniqueKeyParameter={"studentBankAccountDetails"}
                    uploadedFileS3Key={chequeDetailsForm?.attachmentKey}
                    uploadedFileName={"Cheque"}
                    modalTitle={"Upload Attachment"}
                    saveHandler={(s3Key) => {
                        setUploadDialogOpen(false);
                        formHandler("attachmentKey", s3Key)
                    }}
                    modalProps={{ zIndex: 1500 }}
                    key={chequeDetailsForm?.attachmentKey}
                />

            </div>

        </Dialog>
    );
}

export default ChequeDetailsFormDialog;